import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Colors from '../Constant/Colors';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/Container';
import LandingImg from '../assets/Images/startup.svg';
import Idea from '../assets/Images/problem-solving.svg';
import Footer from '../components/Footer/Footer';
import '../components/Footer/Footer.css';
import './style.css';
import Carousel from 'react-bootstrap/Carousel';
import MobApp from '../assets/Images/MobileApp.png';
const LandingPage = () => {
  return (
    <>
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          position={'relative'}
          p={2}
          backgroundColor={Colors.primary}>
          <Box display="flex">
            <Typography
              variant="h4"
              marginLeft="18px"
              color={'white'}
              style={{
                fontVariant: 'small-caps',
                fontWeight: '600',
                letterSpacing: 1,
                textShadow: '1px 1px 5px #370898',
              }}>
              IconicArt
            </Typography>
          </Box>
          <Box display="flex" gap="30px" borderRadius="25px">
            <Button
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                width: '60%',
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: '#fff',
                  color: 'black',
                },
              }}
              href="/register">
              Signup
            </Button>
            <Button
              variant="contained"
              sx={{
                width: '180px',
                backgroundColor: Colors.secondary,
                color: 'black',
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: '#fff',
                  color: 'black',
                },
              }}
              href="/login">
              Login
            </Button>
          </Box>
        </Box>
        <Container className="main" style={{paddingTop:20}} fluid>
          <Row
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Col
              sm={4}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <div>
                <h1
                  style={{
                    fontSize: '3rem',
                    color: 'white',
                    fontWeight: 'bold',
                  }}>
                  IconicArt
                </h1>
                <div
                  style={{
                    fontSize: '20px',
                    color: Colors.secondary,
                    fontWeight: '500',
                  }}>
                  Powerful and effective platform to make connections and
                  increase your creative network !!
                </div>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: 6,
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '50%',
                    backgroundColor: 'aquamarine',
                    color: Colors.primary,
                    fontWeight: '600',
                    letterSpacing: 1,
                    '&:hover': {
                      backgroundColor: Colors.secondary,
                      color: 'white',
                    },
                  }}>
                  Explore our services
                </Button>
              </div>
            </Col>

            <Col
              sm={5}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}>
              <img
                class="img-responsive"
                src={LandingImg}
                style={{ height: '80%', width: '65%' }}
                className="Imganimation"
                alt="landing"
              />
            </Col>
          </Row>
        </Container>
          <svg viewBox="0 0 500 200">
          <path
            d="M 0 50 C 150 150 300 0 500 80 L 500 0 L 0 0"
            fill="#3F3D56"></path>
          <path
            d="M 0 50 C 150 150 330 -30 500 50 L 500 0 L 0 0"
            fill="#3F3D56"
            opacity="0.8"></path>
          <path
            d="M 0 50 C 215 150 250 0 500 100 L 500 0 L 0 0"
            fill="#3F3D56"
            opacity="0.5"></path>
        </svg>
        <Container style={{ marginTop: '-300px', marginBottom: '80px' }}>
          <Row>
            {/* <Col>
            <Carousel
              className="caro"
              style={{ borderRadius: '10px', alignContent: 'center' }}>
              <Carousel.Item interval={2000}>
                <img
                  className="d-block w-100 carousel-img"
                  src={require('../assets/Images/carasouel2.jpg')}
                  alt="Second slide"
                />
                <Carousel.Caption style={{ color: 'black' }}>
                  <p style={{ fontSize: '18px', fontWeight: '500' }}>
                    Discover endless career possibilities with us
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item interval={2000}>
                <img
                  className="d-block w-100 carousel-img"
                  src={require('../assets/Images/carasouel2.jpg')}
                  alt="Second slide"
                />
                <Carousel.Caption style={{ color: 'black' }}>
                  <p style={{ fontSize: '18px', fontWeight: '500' }}>
                    Simplify your job search with our platform.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
            </Col> */}
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 50,
              }}>
              <p
                className="mid-tagline"
                style={{
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: Colors.primary,
                }}>
                "Get discovered, get hired, get inspired - all in one place.
                Join IconicArt today and start your journey to success!"
              </p>
            </Col>
          </Row>
        </Container>

        <Divider style={{color:"black"}}/>

        <Container fluid >
          <Row>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 10,
              }}>
              <img
                src={MobApp}
                style={{ height: '100%', width: '50%' }}
                alt="landing"
              />
            </Col>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 50,
              }}>
              <p
                className="mid-tagline"
                style={{
                  fontSize: '1.7rem',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: Colors.darkpurple,
                  letterSpacing:0
                  // marginLeft:90
                }}>
                "Download our mobile app today!"
                <br />
                <p
                  style={{
                    fontSize: '1.1rem',
                    textAlign: 'center',
                    fontWeight: '400',
                    color: Colors.primary,
                  }}>
                  "Experience art in the palm of your hand with iconicart's
                  mobile version. Wherever you go, inspiration follows."
                </p>
              </p>
            </Col>
          </Row>
        </Container>

        {/* ............................................... */}
        <Container fluid style={{marginTop:"0px"}}>
          <Row >
            <Col >
              <img
                class="img-responsive"
                src={Idea}
                style={{ height: '100%', width: '100%' }}
                alt="landing"
              />
            </Col>
            <Col
              // lg={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <div
                style={{
                  backgroundColor: '#aef8df',
                  padding: '25px',
                  borderRadius: 30,
                  boxShadow: '0.5rem 0.5rem 3rem -1rem black',
                }}>
                <h1
                  style={{
                    fontSize: '1.5rem',
                    color: Colors.primary,
                    fontWeight: 'bold',
                  }}>
                  For Designers
                </h1>
                <div
                  style={{
                    fontSize: '16px',
                    color: Colors.darkblue,
                    padding: '10px 0px',
                  }}>
                  Showcase your skills, connect with recruiters, and launch your
                  careers to new heights!
                </div>
                <Link
                  to="/register/designer-registration"
                  sx={{ listStyle: 'none' }}>
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: 2,
                      borderRadius: 6,
                      color: 'white',
                      backgroundColor: Colors.btncolor,
                    }}>
                    Get Started
                  </Button>
                </Link>

                <div style={{ marginTop: '20px' }}>
                  <h1
                    style={{
                      fontSize: '1.5rem',
                      color: Colors.primary,
                      fontWeight: 'bold',
                    }}>
                    For Recruiter
                  </h1>
                  <div
                    style={{
                      fontSize: '16px',
                      color: Colors.darkblue,
                      padding: '10px 0px',
                    }}>
                    Finding the right designer for your project ? then your
                    search end here.
                  </div>
                  <Link
                    to="/register/recruiter-registration"
                    sx={{ listStyle: 'none' }}>
                    <Button
                      variant="contained"
                      sx={{
                        marginTop: 3,
                        borderRadius: 6,
                        width: '20%',
                        color: 'white',
                        backgroundColor: Colors.btncolor,
                      }}>
                      Hire now
                    </Button>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </>
      <Footer />
    </>
  );
};

export default LandingPage;
